// extracted by mini-css-extract-plugin
export default {"links":"AuthLinks_links__Mrxcm","link":"AuthLinks_link__oozQW"};